<h2 mat-dialog-title>Contact Email</h2>

<mat-dialog-content>
  @if (loading()) {
    <div
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 24px;
      "
    >
      <mat-spinner diameter="30"></mat-spinner>

      <div style="margin-top: 16px;">
        Retrieving email...
      </div>
    </div>
  } @else {
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 12px 0;
      "
    >
      <div
        style="
          flex: 1;
          font-size: 16px;
          word-break: break-all;
        "
      >
        {{ email() }}
      </div>

      <div
        style="
          display: flex;
          align-items: center;
          gap: 10px;
        "
      >
        <a
          mat-icon-button
          [href]="'mailto:' + email()"
          matTooltip="Send Email"
        >
          <mat-icon>email</mat-icon>
        </a>

        <button
          mat-icon-button
          matTooltip="Copy Email"
          (click)="copyEmail()"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>
    Close
  </button>
</mat-dialog-actions>